/* eslint-disable */
import convertList from '../convertList';
// import sign from '../sign';
import  { envDomain } from '@/common/contact-selector/utils/domainConfig'
export default function(config) {
    const moreConfig = {
        totalState: false
    };

    return new Promise((resolve, reject) => {
        const data = {
            group_id: config.groupId,
        };
        _getUinByGroupId(data).then(
            res => {
                if (res.data.uins && res.data.uins.length) {
                    // config.parent.cookie = res.data.cookie;
                    config.parent.loaded = true;
                    res.data.uins = res.data.uins.map(ele=>{return {'uin':ele}});
                    const list = convertList(
                        res.data.uins,
                        {
                            list: 'groupList',
                            groupName: 'name',
                            total: 'totalMember'
                        },
                        moreConfig,
                        config.nodeId
                    );
                    // const oneWayUins = res.data.friends.filter(item => item.isOneWayFriend).map(item => `${item.uin}`);
                    // const selfConfig = config.extendConfig;
                    // console.log(selfConfig);
                    // const newList = sign.oneWayRelationshipChain(list, 'QQFriend', {
                    //     oneWayUins,
                    //     ...selfConfig
                    // });
                    // console.log('oneWayUins', oneWayUins, newList, config);
                    console.log('qqFriends',res.data,list);
                    const result = Object.assign(res.data, {
                        list
                    });
                    resolve(result);
                } else {
                    resolve({
                        list: []
                    });
                }
            },
            err => {
                reject(err);
            }
        );
    });
}

function _getUinByGroupId(data) {
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/v1/b2b/selector/getUinByGroupId`, {
        params:data
    });
}
